<template>
  <v-app-bar
    color="primary"
    elevation="0"
    height="110px"
    class="d-none d-md-block header"   
  >
    <HeaderBase class="p-0" />
  </v-app-bar>
</template>

<script>
import HeaderBase from "@/modules/shared/components/HeaderBase.vue";
export default {
  components: {
    HeaderBase,
  },
};
</script>
<style>
.header{
  flex: 0;
}
  
</style>
